import { staffRequestAction } from "../../../_store";

export const handleReviewMessageToInmateNavigator = (
  direction = "next",
  list,
  indexValue,
  history,
  source,
  dispatch
) => {
  var row = {};
  if (list?.DataList?.length === indexValue) {
    //if in last last need to move first list (from nth to 0)
    row = list?.DataList[0];
    dispatch(staffRequestAction?.updateIndexValue(0));
  } else {
    row = list?.DataList[indexValue];
    dispatch(staffRequestAction?.updateIndexValue(indexValue));
  }

  history.navigate("StaffRequestList/MessageToInmateRequestForm", {
    state: {
      RequestForumMGUserThreadID: row?.RequestForumMGUserThreadID,
      formID: row?.RequestFormTypeID,
      RequestFormType: row?.RequestFormType,
      RequestFormTypeID: row?.RequestFormTypeID,
      InmateID: row?.InmateID,
      InmateResidentId: row?.InmateResidentId,
      formDetails: list,
      sourceFrom: "MessageToInmate",
    },
  });
};
